export default {
  getStaff: "/employee/query", //获取在职人员
  editStaff: "/employee/modify", //修改员工
  addStaff: "/employee/add", //新增员工
  editDepart: "/employee/adjuststaff", //调整部门API
  quit: "/employee/dimission", //离职API
  cancelQuit: "/employee/revocationdimission/{id}", //撤销离职API
  exportAll: "/employee/downloadempreport?status=100001&token=", //导出全部在职
  getDetail: "/employee/getentry/{id}", //获取详情
  downloadAll: "/employee/downloadempreport", //导出全部
}


// WEBPACK FOOTER //
// ./src/api/config/staff.js